import APIClient from '@/shared/http/clients/api'

const resourceName = 'REEmpreendimentoLogArquivo'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const GetByEmpreendimento = (eId, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetByEmpreendimento/${eId}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/${id}`, config)
const Search = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/search`, data, config)

const EnterpriseLogArchiveRepository = {
  GetAll,
  GetByEmpreendimento,
  Create,
  Update,
  Delete,
  Search
}

export default EnterpriseLogArchiveRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/enterpriselogarchive.js